import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const SnippetsMainLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./SnippetsMain'),
                'snippets-main',
            ) as any,
    ),
);

export default SnippetsMainLazy;
